<template>
	<div>
		<buttonlist @help="help" @reflash="reflash" @save="save" ref="SetBtn"></buttonlist>
		<div>
			<!--<span>{{$t('getapi[6818]')}}</span>-->
			<table>
				<tr>
					<td>
						{{$t('getapi[3125]')}}
					</td>
					<td colspan="3"><el-input v-model="dataDetail.fullname" class="mcolor"  type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>
						{{$t('getapi[3109]')}}
					</td>
					<td colspan="3"><el-input v-model="dataDetail.addr" class="mcolor" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3115]')}}</td>
					<td colspan="3"><el-input v-model="dataDetail.http" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[6819]')}}</td>
					<td colspan="3"><el-input v-model="dataDetail.email" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3293]')}}</td>
					<td><el-input v-model="dataDetail.englishname" type="text" size="mini"></el-input></td>
					<td>{{$t('getapi[3123]')}}</td>
					<td><el-input v-model="dataDetail.shortname" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3122]')}}</td>
					<td><el-input v-model="dataDetail.byname1" type="text" size="mini"></el-input></td>
					<td>{{$t('getapi[2587]')}}</td>
					<td><el-input v-model="dataDetail.country" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3120]')}}</td>
					<td><el-input v-model="dataDetail.byname2" type="text" size="mini"></el-input></td>
					<td>{{$t('getapi[2588]')}}</td>
					<td><el-input v-model="dataDetail.area" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>
						{{$t('getapi[6820]')}}
					</td>
					<td><el-input v-model="dataDetail.postcode" class="mcolor" type="text" size="mini"></el-input></td>
					<td>
						{{$t('getapi[6821]')}}
					</td>
					<td><el-input v-model="dataDetail.linkman1" class="mcolor" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>
						{{$t('getapi[3140]')}}
					</td>
					<td><el-input v-model="dataDetail.tel1" class="mcolor" type="text" size="mini"></el-input></td>
					<td>{{$t('getapi[6822]')}}</td>
					<td><el-input v-model="dataDetail.linkman2" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3141]')}}</td>
					<td><el-input v-model="dataDetail.tel2" type="text" size="mini"></el-input></td>
					<td>
						{{$t('getapi[2612]')}}
					</td>
					<td><el-input v-model="dataDetail.fax" class="mcolor" type="text" size="mini"></el-input></td>
				</tr>
				<!--<tr>
					<td>英文名</td>
					<td><el-input v-model="dataDetail.englishname" type="text" size="mini"></el-input></td>
					<td>公司简称</td>
					<td><el-input v-model="dataDetail.shortname" type="text" size="mini"></el-input></td>
				</tr>-->
				<tr>
					<td>{{$t('getapi[3113]')}}</td>
					<td><el-input v-model="dataDetail.loginfund" type="text" size="mini"></el-input></td>
					<td>{{$t('getapi[3111]')}}</td>
					<td><el-input v-model="dataDetail.manager" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3112]')}}</td>
					<td><el-input v-model="dataDetail.logintype" type="text" size="mini"></el-input></td>
					<td>{{$t('getapi[1226]')}}</td>
					<td><el-input v-model="dataDetail.financetype" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3108]')}}</td>
					<td>
						<el-select filterable v-model="dataDetail.currency_code" size="mini" @change="getName">
							<el-option v-for="item in currencyList" :key="item.Code" :label="item.Code" :value="item.Code"></el-option>
						</el-select>
					</td>
					<td colspan="2">
						<span style="color:red">{{$t('getapi[3107]')}}{{ currency_name }}</span>
					</td>
				</tr>
				<tr>
					<td>
						{{$t('getapi[3693]')}}
					</td>
					<td>
						<el-select filterable v-model="dataDetail.tax_code" size="mini" @change="getRate" class="mcolor">
							<el-option v-for="item in rateList" :key="item.tax_code" :label="item.tax_code" :value="item.tax_code"></el-option>
						</el-select>
					</td>
					<td colspan="2">
						<span>{{$t('getapi[6823]')}}{{ tax_rate }}%</span>
					</td>
				</tr>
				<tr>
					<td>{{$t('getapi[3112]')}}</td>
					<td colspan="3"><el-input v-model="dataDetail.remark" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[12576]')}}</td>
					<td colspan="3">
						<el-radio-group v-model="dataDetail.windowstyle" @change="switchStyle">
							<el-radio :label="1">灰</el-radio>
							<el-radio :label="2">绿</el-radio>
							<el-radio :label="3">蓝</el-radio>
							<el-radio :label="4">红</el-radio>
						</el-radio-group>
					</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';

export default {
	name:'company',
	data() {
		return {
			userData: [], // 用户信息
			dataDetail: {},
			currencyList: [],
			rateList: [],
			currency_name: '',
			tax_rate: ''
		};
	},
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.currencyList = Array.methods.getCurrencyList();
		that.rateList = Array.methods.getRateCode();
		that.getView();
		that.authority();
	},
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1062]"),this.$t("getapi[12]"));
        },
		//权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			that.$refs.SetBtn.SetButtonEnable('save,refresh');
		},
		getView() {
			let that = this;
			let data = '';
			that.$http.urlpost('/Sys/Currency/GetCompanyInfo', data, function(res) {
				if (res.Success == 1) {
					that.dataDetail = res.DataContent;
					if(that.dataDetail.windowstyle == 1 || that.dataDetail.windowstyle == 2 || that.dataDetail.windowstyle == 3 || res.DataContent.windowstyle == 4){
					    that.$root.windowstyle == that.dataDetail.windowstyle
					} else {
                        that.$root.windowstyle = 1
					}
					that.getName(that.dataDetail.currency_code);
					that.getRate(that.dataDetail.tax_code);
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		save() {
			let that = this;
			let parm = that.dataDetail;
			that.$http.urlpost('/Sys/Currency/SysCompanySave', parm, function(res) {
				if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
					that.getView()
				}
			});
		},
		getName(val) {
			let that = this;
			for (let i = 0; i < that.currencyList.length; i++) {
				if (that.currencyList[i].Code == val) {
					that.currency_name = that.currencyList[i].Name;
					return;
				}
			}
		},
		getRate(val) {
			let that = this;
			for (let i = 0; i < that.rateList.length; i++) {
				if (that.rateList[i].tax_code == val) {
					that.tax_rate = that.rateList[i].tax_rate;
					return;
				}
			}
		},
        switchStyle(val){
		    this.$root.windowstyle = val
		}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
